export default "__VITE_ASSET__BvU44vhO__"